import { css } from '@linaria/core';
import Intents from '@ux/intents';
const intents = new Intents();

export const sizes = {
  xsmall: '-2',
  small: '-1',
  medium: '0',
  large: '3',
  xlarge: '5'
};

export const classes = {
  'compact': css`
    line-height: 1.25rem !important;
  `,
  'wrap': css`
    word-break: break-word !important;
    overflow-wrap: anywhere !important;
  `,

  'text-left': css` text-align: left !important; justify-content: left !important`,
  'text-right': css` text-align: right !important; justify-content: right !important`,
  'text-center': css` text-align: center !important; justify-content: center !important`,
  'text-justify': css` text-align: justify !important`,

  'font-weight-bold': css` font-weight: bolder !important;`,
  'font-weight-normal': css` font-weight: ${intents.ux.text.fontWeight} !important;`
};

export default (props = {}) => ({

  /* font-weight */
  [classes['font-weight-bold']]: props.bold || props.weight === 'bold',
  [classes['font-weight-normal']]: props.normal || props.weight === 'normal',

  /* font-size */
  [`ux-text ux-text-size${sizes.xsmall}`]: props.xsmall,
  [`ux-text ux-text-size${sizes.small}`]: props.small,
  [`ux-text ux-text-size${sizes.medium}`]: props.medium,
  [`ux-text ux-text-size${sizes.large}`]: props.large,
  [`ux-text ux-text-size${sizes.xlarge}`]: props.xlarge,
  [`ux-text ux-text-size${sizes[props.size] || props.size}`]: props.size,

  /* text-align */
  [classes[`text-${props.align}`]]: props.align,

  /* line-height */
  [classes.compact]: props.compact,

  /* word break */
  [classes.wrap]: props.wrap
});
